import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import {
  Layout,
  HoInvitedHero,
  NewsLetterBar,
} from '../../../v2/components/common';
import {
  HowHoverWorks,
  BringYourHome,
  ReadyToSee,
} from '../../../v2/components/how-does-it-work';

const HowDoesItWork: React.FC = () => (
  <Layout
    title="How it Works"
    description="A better way to build. HOVER makes home improvement simpler, faster and more collaborative. It all starts with a 3D model of your home."
  >
    <HoInvitedHero
      showCtaButton
      body="Home improvement shouldn’t be a mystery. Know what it will look
      like and what it will cost before the work even begins."
      header="Improving home improvement."
      backgroundColor="red.500"
      alignSelf="center"
      mt={0}
      mb={700}
    >
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="how does it work hero"
        src="../../../v2/assets/images/how_does_it_work_hero.png"
      />
    </HoInvitedHero>
    <HowHoverWorks />
    <BringYourHome />
    <ReadyToSee />
    <NewsLetterBar bg="red.500" iconColor="yellow.500" />
  </Layout>
);

export default HowDoesItWork;
